import { Link } from "react-router-dom";

export function Logo({ size = "md", withWordmark = true, to = "/" }) {
  const imgClass = size === "lg" ? "h-11 w-auto" : size === "sm" ? "h-8 w-auto" : "h-9 w-auto";
  const img = (
    <img
      src="/assets/logo.png"
      alt="Creative Solution logo"
      className={`${imgClass} rounded-full ring-1 ring-slate-200 object-cover bg-white`}
    />
  );
  if (!withWordmark) return to ? <Link to={to} data-testid="brand-logo-link">{img}</Link> : img;
  return (
    <Link to={to} className="flex items-center gap-2.5" data-testid="brand-logo-link">
      {img}
      <span className="font-display leading-none">
        <span className="block text-[15px] font-bold tracking-tight text-slate-900">
          Creative Solution
        </span>
        <span className="block text-[11px] font-semibold tracking-[0.22em] text-orange-600 uppercase">
          AI
        </span>
      </span>
    </Link>
  );
}

export const STATUS_STYLES = {
  working: "bg-emerald-50 text-emerald-700 border-emerald-200",
  connected: "bg-emerald-50 text-emerald-700 border-emerald-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "needs attention": "bg-orange-50 text-orange-800 border-orange-200",
  paused: "bg-slate-100 text-slate-600 border-slate-300",
  disconnected: "bg-red-50 text-red-700 border-red-200",
  "connection failed": "bg-red-50 text-red-700 border-red-200",
  "setup required": "bg-slate-100 text-slate-600 border-slate-200",
  "not connected": "bg-orange-50 text-orange-700 border-orange-200",
  "needs you": "bg-orange-50 text-orange-800 border-orange-200",
  resolved: "bg-slate-100 text-slate-500 border-slate-200",
};

export function StatusBadge({ label, className = "" }) {
  const style = STATUS_STYLES[label.toLowerCase()] || STATUS_STYLES["setup required"];
  const dot =
    label.toLowerCase().includes("fail") || label.toLowerCase().includes("disconnect")
      ? "bg-red-500"
      : label.toLowerCase().includes("attention") || label.toLowerCase().includes("needs")
      ? "bg-orange-500"
      : label.toLowerCase() === "paused" || label.toLowerCase() === "resolved"
      ? "bg-slate-400"
      : label.toLowerCase().includes("not connected") || label.toLowerCase().includes("setup")
      ? "bg-orange-500"
      : "bg-emerald-500";
  return (
    <span
      data-testid={`status-badge-${label.toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${style} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
      {label}
    </span>
  );
}
